import { render } from "./file-earmark-slides.vue?vue&type=template&id=6edbbb7a"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/file-earmark-slides.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6edbbb7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6edbbb7a', __exports__)) {
    api.reload('6edbbb7a', __exports__)
  }
  
  module.hot.accept("./file-earmark-slides.vue?vue&type=template&id=6edbbb7a", () => {
    api.rerender('6edbbb7a', render)
  })

}


export default __exports__